module.exports = __webpack_public_path__ + "img/Download.5714981e.png";